import debounce from "lodash/debounce";
import { ChangeEventHandler, InputHTMLAttributes, useCallback, useEffect, useState } from "react";

import * as Styles from "./Range.styles";

export interface RangeProps extends InputHTMLAttributes<HTMLInputElement> {}

export function Range({ children, onChange, value, ...rest }: RangeProps) {
  const [localValue, setValue] = useState(value);

  const debounceChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    debounce((event) => {
      setValue(event.target.value);
      onChange?.(event);
    }, 100),
    [onChange]
  );

  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      setValue(event.target.value);
      onChange?.(event);
    },
    [onChange]
  );

  useEffect(() => {
    if (value !== localValue) {
      setValue(localValue);
    }
  }, [value, localValue]);

  return <Styles.Input type="range" {...rest} onChange={handleChange} value={localValue} />;
}
